module.exports = __webpack_public_path__ + "img/particle_motion_00075.e269884b.png";